import { render } from "./AppTabs.vue?vue&type=template&id=56574b2e&scoped=true"
import script from "./AppTabs.vue?vue&type=script&lang=js"
export * from "./AppTabs.vue?vue&type=script&lang=js"

import "./AppTabs.vue?vue&type=style&index=0&id=56574b2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56574b2e"]])

export default __exports__